<div class="mech-diag-content">
	<app-raw-select [asset]="asset" [fleet]="fleet" [component]="component" [shaft]="shaft" (rawSelected)="rawSelected($event)"></app-raw-select>
	<div *ngIf="selectedraw" class="detail-panel">
		<app-tach-detail *ngIf="component.type === 'tach'" [asset]="asset" [component]="component" [raw]="selectedraw"></app-tach-detail>
		<app-shaft-detail *ngIf="component.type === 'shaft'" [asset]="asset" [component]="component" [raw]="selectedraw"></app-shaft-detail>
		<app-gear-detail *ngIf="component.type === 'gear'" [asset]="asset" [component]="component" [shaft]="shaft" [raw]="selectedraw"></app-gear-detail>
		<app-bearing-detail *ngIf="component.type === 'bearing'" [asset]="asset" [component]="component" [shaft]="shaft" [raw]="selectedraw"></app-bearing-detail>
		<app-motorshaft-detail *ngIf="component.type === 'motorshaft'" [asset]="asset" [component]="component" [raw]="selectedraw"></app-motorshaft-detail>
		<app-motor-detail *ngIf="component.type === 'motor'" [asset]="asset" [component]="component" [shaft]="shaft" [raw]="selectedraw"></app-motor-detail>
		<app-motorbearing-detail *ngIf="component.type === 'motorbearing'" [asset]="asset" [component]="component" [shaft]="shaft"
		 [raw]="selectedraw"></app-motorbearing-detail>
		<app-current-detail *ngIf="component.type === 'current'" [asset]="asset" [component]="component" [raw]="selectedraw"></app-current-detail>
		<app-impact-detail *ngIf="component.type === 'impact'" [asset]="asset" [component]="component" [raw]="selectedraw"></app-impact-detail>
		<app-sensor-detail *ngIf="component.type === 'sensor'" [asset]="asset" [component]="component" [raw]="selectedraw"></app-sensor-detail>
		<!-- <div class="download-button">
			<div class="btn-group">
				<button (click)="DownloadRaw('raw', 'raw')" type="button" class="btn btn-primary">Download Raw Data</button>
				<div class="btn-group" ngbDropdown role="group">
					<button class="btn btn-primary dropdown-toggle-split" ngbDropdownToggle></button>
					<div class="dropdown-menu" ngbDropdownMenu>
						<button (click)="DownloadRaw('base64', 'txt')" class="dropdown-item">Base64</button>
					</div>
				</div>
			</div>
		</div> -->
	</div>
</div>